import { Modal, Text } from "@shopify/polaris";
import Langauge from "../../i18n/Language";
import { useState } from "react";
import { reqGetUserInput } from "../../api";

const t = Langauge;

const UnfinishedBlogModal = ({
    open,
    loading = false,
    recordId = -1,
    onStartNew,
    onContinue,
    onClose,
    toggleToast,
}) => {

    const [newStartLoading, setNewStartLoading] = useState(false); // 开始新任务加载中

    // 开始新任务
    const handleOnStartNew = async () => {
        try {
            if (recordId === -1) {
                handleToggleToast();
            } else {
                setNewStartLoading(true);
                // 先舍弃上一次任务
                let params = {
                    record_id: recordId,
                    type: "abandon",
                };
                const res = await reqGetUserInput(params);
                if (res.ack === 1) {
                    onStartNew();
                } else {
                    handleToggleToast();
                }
                setNewStartLoading(false);
            }
        } catch (error) {
            console.log(error);
            handleToggleToast();
        }
    }

    // 切换toast
    const handleToggleToast = () => {
        toggleToast && toggleToast(t("Try again later"), true);
    }


    return (
        <Modal
            size="small"
            open={open}
            title={t("You have an unfinished blog")}
            primaryAction={{
                content: t("Start a new blog"),
                onAction: handleOnStartNew,
                loading: newStartLoading,
                disabled: loading,
            }}
            secondaryActions={[
                {
                    content: t("Continue task"),
                    onAction: onContinue,
                    loading: loading,
                    disabled: newStartLoading,
                },
            ]}
            onClose={() => {
                if (!loading) {
                    onClose?.();
                }
            }}
        >
            <Modal.Section>
                <Text variant="bodyMd" as="p" tone="base">{t("Choose how you'd like to proceed")}:</Text>
                <ul className="generating_tip_list">
                    <li>{t("Continue your unfinished blog task")}</li>
                    <li>{t("Clear it and start a new one")}</li>
                </ul>
            </Modal.Section>
        </Modal>
    );
};

export default UnfinishedBlogModal;
